import ThemeContext, { useTheme as useThemeContext } from '../context/ThemeContext';

/**
 * ThemeController: thin, reusable controller for theme operations.
 * - Prefer the hook `useThemeController()` inside React components.
 * - Static helpers work with persistence for non-React usage.
 */
class ThemeController {
  static STORAGE_KEY = 'theme_mode';

  static getStoredMode() {
    try { return window.localStorage.getItem(ThemeController.STORAGE_KEY); } catch { return null; }
  }

  static setStoredMode(mode) {
    try { window.localStorage.setItem(ThemeController.STORAGE_KEY, mode === 'dark' ? 'dark' : 'light'); } catch {}
  }

  static clearStoredMode() {
    try { window.localStorage.removeItem(ThemeController.STORAGE_KEY); } catch {}
  }
}

/**
 * Hook wrapper that exposes a clean controller-like API in React.
 */
export const useThemeController = () => {
  const { isDarkMode, themePreference, toggleTheme, setThemeMode, primaryColor, changePrimaryColor } = useThemeContext();

  const setMode = (mode) => setThemeMode(mode);
  const toggle = () => toggleTheme();
  const setPrimary = (color) => changePrimaryColor(color);

  return {
    // state
    isDarkMode,
    themePreference,
    primaryColor,
    // actions
    toggle,
    setMode,
    setPrimary,
  };
};

export default ThemeController;
